import React from 'react';
import PropTypes from 'prop-types';
import modernEnvironment from '../../lib/RelayUtils';
import {graphql, QueryRenderer} from 'react-relay';
// material
import { mediaFilesListQuery } from '../../queries'
import Dialog from 'material-ui/Dialog';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import IconButton from 'material-ui/IconButton';
// media
import MediaGalleryList from './MediaGalleryList';

let currentWindowState = '';

const propTypes = {
    insertAfterUpload: PropTypes.bool,
    insertAfterClick: PropTypes.bool
};

const defaultProps = {
    insertAfterUpload: false,
    insertAfterClick: true,
};

class PopupGallery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: this.props.open,
            type: this.props.type,
            orientation: this.props.orientation,
            orientationShow: this.props.orientationShow,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.state.open) {
            this.setState({
                open: nextProps.open,
            })
        }
        if (nextProps.type !== this.state.type) {
            this.setState({
                type: nextProps.type,
            })
        }
    }

    closeModal() {
        this.props.closeDialogHandle();
    }

    render() {
        if (!this.state.open) {
            return <div/>;
        }
        return (
            <QueryRenderer
                environment={modernEnvironment}
                query={mediaFilesListQuery}
                variables={{
                    page: 1,
                    types: this.state.type,
                    sort: 'dateDesc',
                    states: ['available'],
                }}
                render={({error, props}) => {
                    if (error) {
                        return (<div>{error.message}</div>)
                    }
                    if (props) {
                        let viewType = this.state.mediaGalleryViewType;
                        let updateState = false;
                        if (currentWindowState !== this.state.openMediaGallery) {
                            currentWindowState = this.state.openMediaGallery;
                            updateState = true;
                        }
                        return <Dialog
                            bodyClassName='js-gallery-modal gallery-modal'
                            modal={false}
                            open={this.state.open}
                            autoScrollBodyContent={true}
                            contentStyle={{
                                width: '81%',
                                maxWidth: 'none',
                                height: '80%',
                                maxHeight: 'none',
                                padding: 0
                            }}
                            bodyStyle={{
                                padding: 0
                            }}
                            onRequestClose={() => {
                                updateState = false;
                                this.closeModal();
                            }}
                        >
                            <IconButton
                                style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: 9,
                                    zIndex: 2
                                }}
                                onClick={() => {
                                    this.closeModal()
                                }}
                            >
                                <CloseIcon hoverColor='#542376'/>
                            </IconButton>
                            <div style={{marginTop: -2}}>
                                <MediaGalleryList
                                    viewer={props.viewer}
                                    styleTitle={{
                                        marginRight: 59
                                    }}
									routePersistentPage={false}
                                    setViewType={type => {
                                        viewType = type;
                                    }}
                                    insertItem={item => {
                                        this.props.insertMediaFile(item, viewType);
                                    }}
                                    insertAfterClick={this.props.insertAfterClick}
                                    insertAfterUpload={this.props.insertAfterUpload}
                                    insertMultipleMediaFiles={this.props.insertMultipleMediaFiles}
                                    type={this.props.type}
                                    pagination={false}
                                    wrapper='js-gallery-modal'
                                    update={updateState}
                                    componentState={true}
                                    orientation={this.state.orientation}
                                    orientationShow={this.props.orientationShow}
                                />
                            </div>
                        </Dialog>;
                    }
                    return (<div/>);
                }}
            />
        );
    }
}

PopupGallery.propTypes = propTypes;
PopupGallery.defaultProps = defaultProps;

export default PopupGallery;



// WEBPACK FOOTER //
// src/components/media/PopupGallery.js